module.exports = __webpack_public_path__ + "img/banner-10.aa9ddfbd.jpg";